import { useContext, useEffect, useRef, useState } from 'react';

import { FilterContextData } from 'contexts/FilterContext';
import { usePackArchitectureContext } from 'contexts/PackArchitectureContext';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    PPA_PACK_ARCH_PAGE_TIME_SPENT,
    PPA_PACK_ARCH_VIEWED,
} from 'utils/mixpanelEventNames';

import { buildPackArchitectureGlobalFiltersSummary } from './packArchitectureGlobalFilters.helpers';
import { usePackArchitectureGlobalFilterTracking } from './usePackArchitectureGlobalFilterTracking';

const getPackArchitectureEntryPoint = () => window.location.pathname.replace(/^\/+/, '') || 'direct';

/** Page view + session duration + global-filter Mixpanel for Pack Architecture. */
export function usePackArchitecturePageTracking() {
    const { chartRequest } = usePackArchitectureContext();
    const {
        allCheckedAttribute,
        timeSelectionLabel,
        timePeriodList,
    } = useContext(FilterContextData);

    const [initialGlobalFilters] = useState(() =>
        buildPackArchitectureGlobalFiltersSummary({
            timeSelectionLabel,
            chartRequest,
            timePeriodList,
            allCheckedAttribute,
        }),
    );

    const pageLoadTimeRef = useRef<number>(Date.now());
    useEffect(() => {
        trackEventMixpanel(PPA_PACK_ARCH_VIEWED, {
            entry_point: getPackArchitectureEntryPoint(),
            global_filters_applied: initialGlobalFilters || '-',
        });
        const loadTime = pageLoadTimeRef.current;
        return () => {
            trackEventMixpanel(
                PPA_PACK_ARCH_PAGE_TIME_SPENT,
                { session_duration_sec: Math.round((Date.now() - loadTime) / 1000) },
                { keepalive: true },
            );
        };
    }, [initialGlobalFilters]);

    usePackArchitectureGlobalFilterTracking();
}
